import { useEffect, useState } from 'react';
import { api } from 'services/api';

import { ITourCodesType } from '../models/product';

export function useTourCodes(): ITourCodesType[] {
  const [productTourCodes, setProductTourCodes] = useState<ITourCodesType[]>(
    []
  );

  useEffect(() => {
    api
      .get<{ data: { code6: string; description: string }[] }>(
        '/admin/filter-options/tour-codes'
      )
      .then(({ data }) => {
        setProductTourCodes(
          data
            .map(item => ({
              code6: item.code6 || '',
              code6_description: item.description || ''
            }))
            .filter(item => !!item.code6)
        );
      })
      .catch(err => Promise.reject(err.message));
  }, []);

  return productTourCodes;
}
